import { Carousel3D } from "./Carousel3D";
import { ecosystemModules, ecosystemKpis } from "./ecosystemModules";

// Panel derecho versión "El ecosistema que no duerme" — rueda 3D de tarjetas
// de módulos (eje X) + 3 KPIs grandes.
export function EcosystemPanel({ t }) {
  return (
    <div className="ecosystem-panel">
      <span className="ecosystem-panel__star" style={{ left: "10%", top: "12%", animationDuration: "4.5s" }} />
      <span className="ecosystem-panel__star" style={{ left: "84%", top: "20%", animationDuration: "5.5s", animationDelay: ".7s" }} />
      <span className="ecosystem-panel__star ecosystem-panel__star--mid" style={{ left: "24%", top: "70%", animationDuration: "6s", animationDelay: ".3s" }} />

      <div className="ecosystem-panel__header">
        <div>
          <div className="ecosystem-panel__kicker">{t("login_ecosystem_kicker")}</div>
          <h2 className="ecosystem-panel__title">
            {t("login_ecosystem_title_1")}<span>{t("login_ecosystem_title_2")}</span>
          </h2>
        </div>
        <span className="ecosystem-panel__count">{t("login_ecosystem_count")}</span>
      </div>

      <div className="ecosystem-panel__body">
        <div className="ecosystem-panel__kpis">
          {ecosystemKpis.map((kpi, i) => (
            <div key={kpi.label} className="ecosystem-panel__kpi">
              {i > 0 && <div className="ecosystem-panel__kpi-divider" />}
              <span className="ecosystem-panel__kpi-label">
                <span className="ecosystem-panel__kpi-dot" style={{ background: kpi.dot }} />
                {kpi.label}
              </span>
              <div className="ecosystem-panel__kpi-value">
                {kpi.value}
                {kpi.unit && <span> {kpi.unit}</span>}
              </div>
            </div>
          ))}
        </div>

        <Carousel3D
          modules={ecosystemModules}
          axis="x"
          cardWidth={250}
          cardHeight={140}
          radius={275}
          duration={36}
          maskAxis="vertical"
        />
      </div>

      <div className="ecosystem-panel__footer">
        <span>{t("login_ecosystem_footer_left")}</span>
        <span className="ecosystem-panel__footer-accent">SUSTEMIA · LATAM</span>
      </div>
    </div>
  );
}
